
<script>
import { mapState, mapActions } from "vuex";
import Lines from "@/components/chart/Line";
import Bar from "@/components/chart/Bar";

export default {
   data() {
      return {
         chartLoading: false,
         chartdata: null,
         chartLingkungan: null,
      };
   },
   components: { Lines, Bar },
   async mounted() {
      this.chartLoading = false;
      await this.getData().then((res) => {
         this.chartLoading = true;
         // this.chartdata.labels = this.chart.baptis.labels;
         // this.chartdata.datasets[0].data = this.chart.baptis.series;

         this.chartdata = {
            labels: res.data.baptis_chart.labels,
            datasets: [
               {
                  backgroundColor: "rgba(145, 46, 252, 0.3)",
                  borderColor: "rgba(145, 46, 252, 0.8)",
                  strokeColor: "#7366ff",
                  pointBackgroundColor: "#7366ff",
                  pointHoverBackgroundColor: "#fff",
                  pointHoverBorderColor: "#fff",
                  pointHighlightStroke: "#000",
                  data: res.data.baptis_chart.series,
                  label: "Baptis",
               },
            ],
         };

         this.chartLingkungan = {
            labels: res.data.lingkungan_chart.labels,
            datasets: [
               {
                  borderWidth: 1,
                  borderRadius: 15,
                  borderSkipped: false,
                  barThickness: 20,
                  backgroundColor: "rgba(145, 46, 252, 0.4)",
                  borderColor: "rgba(145, 46, 252, 0.6)",
                  hoverBackgroundColor: "rgba(145, 46, 252, 0.6)",
                  data: res.data.lingkungan_chart.series,
                  label: "Umat",
               },
               {
                  borderWidth: 1,
                  borderRadius: 15,
                  borderSkipped: false,
                  barThickness: 20,
                  backgroundColor: "rgba(31, 108, 175, 1)",
                  borderColor: "rgba(18, 94, 161, 1)",
                  hoverBackgroundColor: "rgba(8, 132, 241, 1)",
                  data: res.data.lingkungan_chart.series_kk,
                  label: "Keluarga Katolik",
               },
            ],
         };
      });
   },
   created() { },
   computed: {
      ...mapState({
         status: (state) => state.dashboard.status,
         chart: (state) => state.dashboard.chart,
      }),
      isLoading() {
         return this.$store.state.isLoading;
      },
   },
   methods: {
      ...mapActions({
         getData: "dashboard/getAll",
      }),
      onOpenMaps() {
         window.open("https://peta.parkatkrsintang.id/", '_blank');
      }
   },
};
</script>

<template>
   <div>
      <Breadcrumbs title="Dashboard" />
      <!-- Container-fluid starts-->
      <div class="container-fluid">
         <div class="row">
            <div class="col-lg-12">
               <div class="row">
                  <div class="col-sm-12 col-md-6">
                     <px-card class="bg-dark static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="user" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Umat</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.umat | formatNumber }}
                                 </h4>
                                 <feather type="user" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
                  <div class="col-sm-12 col-md-6">
                     <px-card class="bg-dark static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="users" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Keluarga Katolik</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.kk | formatNumber }}
                                 </h4>
                                 <feather type="users" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
                  <div class="col-sm-12 col-md-3">
                     <px-card class="bg-primary static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="user-plus" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Baptis</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.baptis | formatNumber }}
                                 </h4>
                                 <feather type="user-plus" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
                  <div class="col-sm-12 col-md-3">
                     <px-card class="bg-primary static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="moon" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Komuni I</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.komuni | formatNumber }}
                                 </h4>
                                 <feather type="moon" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
                  <div class="col-sm-12 col-md-3">
                     <px-card class="bg-primary static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="user-check" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Krisma</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.krisma | formatNumber }}
                                 </h4>
                                 <feather type="user-check" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
                  <div class="col-sm-12 col-md-3">
                     <px-card class="bg-primary static-top-widget-card">
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="link" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Total Perkawinan</span>
                                 <h4 class="mb-0 counter">
                                    {{ status.total.perkawinan | formatNumber }}
                                 </h4>
                                 <feather type="link" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
               </div>
               <div class="row">
                  <div class="col-sm-12 col-md-12" @click="onOpenMaps()">
                     <px-card class="bg-dark static-top-widget-card bg-maps" >
                        <div slot="with-padding">
                           <div class="media static-top-widget">
                              <div class="align-self-center text-center">
                                 <feather type="map-pin" class="middle"></feather>
                              </div>
                              <div class="media-body">
                                 <span class="m-0">Paroki Katedral Kristus Raja Sintang</span>
                                 <h4 class="mb-0 counter">
                                    Peta Wilayah Lingkungan
                                 </h4>
                                 <feather type="map-pin" class="icon-bg"></feather>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
               </div>
               <hr />
            </div>

            <div class="col-lg-6">
               <px-card>
                  <div slot="headerAction"></div>
                  <div slot="with-padding">
                     <h6 class="text-muted">Total Tahun ini ({{ $moment().year() }})</h6>
                     <hr />
                     <px-card class="widget-joins ">
                        <div class="row">
                           <div class="col-sm-6 pr-0">
                              <div class="media border-after-xs ">
                                 <div class="media-body details pl-3 ">
                                    <span class="mb-1">Baptis</span>
                                    <h4 class="mb-0 counter digits">
                                       {{
                                          status.total_year.baptis
                                          | formatNumber
                                       }}
                                    </h4>
                                 </div>
                                 <div class="media-body align-self-center">
                                    <feather class="font-primary float-left ml-2" type="user-plus"></feather>
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6 pl-0">
                              <div class="media">
                                 <div class="media-body details pl-3">
                                    <span class="mb-1">Komuni I</span>
                                    <h4 class="mb-0 counter digits">
                                       {{
                                          status.total_year.komuni
                                          | formatNumber
                                       }}
                                    </h4>
                                 </div>
                                 <div class="media-body align-self-center">
                                    <feather class="font-primary float-left ml-3" type="moon"></feather>
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6 pr-0">
                              <div class="media border-after-xs">
                                 <div class="media-body details pl-3 pt-0">
                                    <span class="mb-1">Krisma</span>
                                    <h4 class="mb-0 counter digits">
                                       {{
                                          status.total_year.krisma
                                          | formatNumber
                                       }}
                                    </h4>
                                 </div>
                                 <div class="media-body align-self-center">
                                    <feather class="font-primary float-left ml-2" type="user-check"></feather>
                                 </div>
                              </div>
                           </div>
                           <div class="col-sm-6 pl-0">
                              <div class="media">
                                 <div class="media-body details pl-3 pt-0">
                                    <span class="mb-1">Perkawinan</span>
                                    <h4 class="mb-0 counter digits">
                                       {{
                                          status.total_year.perkawinan
                                          | formatNumber
                                       }}
                                    </h4>
                                 </div>
                                 <div class="media-body align-self-center">
                                    <feather class="font-primary float-left ml-2" type="link"></feather>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </px-card>
                  </div>
               </px-card>
            </div>

            <div class="col-lg-6">
               <px-card>
                  <div slot="headerAction"></div>
                  <div slot="with-padding">
                     <h6 class="text-muted">Total Baptis (5 Tahun)</h6>
                     <hr />
                     <Lines v-if="chartLoading" :chartdata="chartdata" class="chart-height-baptis" />
                  </div>
               </px-card>
            </div>

            <div class="col-lg-12">
               <px-card>
                  <div slot="headerAction"></div>
                  <div slot="with-padding">
                     <h6 class="text-muted">Total Umat Per Lingkungan/Stasi</h6>
                     <hr />
                     <Bar v-if="chartLoading" :chartdata="chartLingkungan" class="chart-height" />
                  </div>
               </px-card>
            </div>
         </div>
      </div>
      <!-- Container-fluid Ends-->
   </div>
</template>

<style scoped>
.chart-height-baptis {
   max-height: 200px;
}

.chart-height {
   max-height: 340px;
}

.bg-maps {
   background-image: url("/img/peta.png");
   background-size: cover;
   background-position: center;
   cursor: pointer;
}
</style>